import { GetServiceCollectionServiceCollectionRequestParams, ServiceService } from '../openapi';
import { map, Observable } from 'rxjs';
import { ServiceListItem } from './service.common.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServiceCommonService {
  constructor(private serviceService: ServiceService) {
  }

  public loadServices(params: GetServiceCollectionServiceCollectionRequestParams): Observable<ServiceListItem[]> {
    return this.serviceService.getServiceCollectionServiceCollection(params).pipe(
      map(services => services.map(service => ({
        ...service,
        tag: `${service?.name || ''} ${service?.description || ''}`
      })))
    );
  }
}
